import {
  genericBeforeValidate_removeDefaultKeyedError,
  GenericForm,
  GenericFormLogicalField,
  GenericFormValidation_YieldEvent,
  GenericTextFieldValidationOptions,
  ValidationEvent,
} from "../../../Common";

import { DataMutableSourceShippingClientStorageDataConsumerInterface } from "../data-mutable-source-shipping-client-storage-data-provider";

export interface AppMinimumRequirementsFor_IsBillingAndShippingTheSame {
  shippingClientStorageData: DataMutableSourceShippingClientStorageDataConsumerInterface;
}

interface IsBillingAndShippingTheSameFormLogicProps<
  Form extends GenericForm,
  App extends AppMinimumRequirementsFor_IsBillingAndShippingTheSame
> {
  required?: boolean;
  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

export enum FormFieldExtensionKeys_IsBillingAndShippingTheSame {
  HasMigratedClientStorageDataToTheInMemoryForm = "_hasMigratedClientStorageDataToTheInMemoryForm",
}

export const isBillingAndShippingTheSameFormLogic = <
  Form extends GenericForm,
  App extends AppMinimumRequirementsFor_IsBillingAndShippingTheSame
>(
  props: IsBillingAndShippingTheSameFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,

  produceEffectDependencies: (context) => [
    context.form[
      `${context.name}${FormFieldExtensionKeys_IsBillingAndShippingTheSame.HasMigratedClientStorageDataToTheInMemoryForm}`
    ],
    context.app.shippingClientStorageData.hasInitialized,
    context.app.shippingClientStorageData
      .lastSelected_isBillingAndShippingTheSame,
  ],
  handleEffect: (context) => {
    const {
      hasInitialized: shippingClientStorageData_hasInitialized,
      lastSelected_isBillingAndShippingTheSame,
    } = context.app.shippingClientStorageData;

    const hasInitialized = shippingClientStorageData_hasInitialized;
    const hasMigratedClientStorageDataToTheInMemoryForm =
      context.form[
        `${context.name}${FormFieldExtensionKeys_IsBillingAndShippingTheSame.HasMigratedClientStorageDataToTheInMemoryForm}`
      ];
    if (!hasMigratedClientStorageDataToTheInMemoryForm && hasInitialized) {
      if (
        lastSelected_isBillingAndShippingTheSame !== undefined &&
        lastSelected_isBillingAndShippingTheSame !== null
      ) {
        const yield_setIsBillingAndShippingTheSame: GenericFormValidation_YieldEvent =
          {
            name: context.name,
            validationEvent: ValidationEvent.onChange,
            value: lastSelected_isBillingAndShippingTheSame,
          };
        context.yield.validationEvent(
          context,
          yield_setIsBillingAndShippingTheSame
        );
      }

      const yield_setHasMigratedClientStorageDataToTheInMemoryForm: GenericFormValidation_YieldEvent =
        {
          name: `${context.name}${FormFieldExtensionKeys_IsBillingAndShippingTheSame.HasMigratedClientStorageDataToTheInMemoryForm}`,
          validationEvent: ValidationEvent.onChange,
          value: true,
        };
      context.yield.validationEvent(
        context,
        yield_setHasMigratedClientStorageDataToTheInMemoryForm
      );
    }
  },

  validationEvents: [ValidationEvent.onSubmit],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: (context) => {},
});
